<div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
    <app-userWorkgroupList [workgroups]="workgroups" [isOnlyCustomer]="isOnlyCustomer"
        (removeWorkgroupFromUser)="removeWorkgroup($event)">
    </app-userWorkgroupList>
</div>